
import { Outlet } from "react-router-dom";

const MainContent = () => {
    return (
        <main className="flex-1 py-1 px-6 bg-white shadow-md m-4 rounded-lg overflow-auto">
            <Outlet />
        </main>
    );
};

export default MainContent;
